export const saved = state => {
  return state.saved
}
export const loading = state => {
  return state.loading
}
export const data = state => {
  return state
}
export const redirect = state => {
  return state
}
